export enum HistoryLogAction {
  CREATED = 'created',
  COPIED = 'copied'
}

export interface HistoryLog {
  ownerName: string
  ownerAvatarUrl: string
  action: HistoryLogAction
  date: string
  publicProjectName: string
  projectUrl?: string
}
